import { z } from 'zod';
import { addressZodSchema } from '@shared/schemas/address';
import { InternationalizeString } from '@shared/modules/translation/model';
import { DiagnosticsBreakdownType } from '@modules/diagnostics/model';

export enum TrackingStatus {
  OUV = 'OUV',
  MATR = 'MATR',
  ENCO = 'ENCO',
  MATE = 'MATE',
  FERM = 'FERM',
}

export interface TrackingStep {
  label: string;
  status: TrackingStatus;
}

export const trackingStatusIndex: Record<TrackingStatus, number> = {
  [TrackingStatus.OUV]: 1,
  [TrackingStatus.MATR]: 2,
  [TrackingStatus.ENCO]: 3,
  [TrackingStatus.MATE]: 4,
  [TrackingStatus.FERM]: 5,
};

export const trackingStatusUiIndex: Record<TrackingStatus, number> = {
  [TrackingStatus.OUV]: 1,
  [TrackingStatus.MATR]: 1,
  [TrackingStatus.ENCO]: 2,
  [TrackingStatus.MATE]: 2,
  [TrackingStatus.FERM]: 3,
};

export interface Ticket {
  number: number;
  creationDate: string;
  diagnosticName: InternationalizeString;
  equipmentSerialId: string;
  trackingStatus: TrackingStatus;
  breakdownType: DiagnosticsBreakdownType;
}

export const checkSerialSchema = z.object({
  equipmentSerialId: z.string().min(1),
});

export type CheckSerialParams = z.infer<typeof checkSerialSchema>;

const userTicketParamsSchema = z.object({
  lastName: z.string().min(1),
  firstName: z.string().min(1),
  companyName: z.string().nullish(),
  address: addressZodSchema,
  phoneNumber: z.string().min(1),
});

export const createTicketParamsSchema = z.object({
  answerId: z.string().min(1),
  user: userTicketParamsSchema,
  comment: z.string().nullish(),
});

export type CreateTicketParams = z.infer<typeof createTicketParamsSchema>;
